import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@css/index.scss' // 公共 css
import '@css/mixin.scss'
import globalMethods from './libs/global'
import * as filters from './libs/filters'

// 引入全局样式
import '@css/init.css'
import 'amfe-flexible'

// 引入全局Utils
import utils from './libs/utils'

Vue.prototype.$utils = utils

import jiguang from './libs/jiguang'

Vue.prototype.$jiguang = jiguang

// 全局注册和客户端交互方法
import Bridge from '@/libs/bridge'

Vue.prototype.$bridge = Bridge

import emoji from '@/components/emoji/index'

Vue.use(emoji)

// 全局注册toast组件
import toastRegistry from './components/toast/index'
// 这里也可以直接执行 toastRegistry()
Vue.use(toastRegistry)
import {
  Button,
  Toast,
  Sticky,
  Tab,
  Tabs,
  NavBar,
  Popup,
  Picker,
  Cell, CellGroup,
  Field,
  Stepper,
  Icon,
  Dialog,
  Uploader,
  DatetimePicker,
  List,
  Search,
  Checkbox,
  CheckboxGroup,
  IndexBar,
  IndexAnchor,
  Radio,
  RadioGroup,
  Tag,
  Rate,
  Col,
  Row,
  TreeSelect,
  Popover,
  Area,
  Badge,
  ImagePreview,
  Loading,
  Card,
  Image as VanImage,
  Step,
  Steps,
  Form,
  NoticeBar,
  Swipe,
  SwipeItem,
  Lazyload,
  Tabbar,
  TabbarItem,
  Overlay,
  DropdownMenu,
  DropdownItem,
  PullRefresh,
  Grid,
  GridItem
} from 'vant'

Vue.use(Button)
  .use(Toast)
  .use(Sticky)
  .use(Tab)
  .use(Tabs)
  .use(NavBar)
  .use(Popup)
  .use(Picker)
  .use(Cell).use(CellGroup)
  .use(Field)
  .use(Stepper)
  .use(Icon)
  .use(Dialog)
  .use(Uploader)
  .use(DatetimePicker)
  .use(List)
  .use(Search)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Radio)
  .use(RadioGroup)
  .use(Tag)
  .use(Rate)
  .use(Col)
  .use(Row)
  .use(TreeSelect)
  .use(Popover)
  .use(Area)
  .use(Badge)
  .use(ImagePreview)
  .use(Loading)
  .use(Card)
  .use(VanImage)
  .use(Step)
  .use(Steps)
  .use(Form)
  .use(NoticeBar)
  .use(Swipe)
  .use(SwipeItem)
  .use(Lazyload)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Overlay)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(PullRefresh)
  .use(Grid)
  .use(GridItem)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false
Vue.use(globalMethods)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
